import { render, staticRenderFns } from "./stockUpReceiveOrders.vue?vue&type=template&id=501fabea&scoped=true"
import script from "./stockUpReceiveOrders.vue?vue&type=script&lang=js"
export * from "./stockUpReceiveOrders.vue?vue&type=script&lang=js"
import style0 from "./stockUpReceiveOrders.vue?vue&type=style&index=0&id=501fabea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fabea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501fabea')) {
      api.createRecord('501fabea', component.options)
    } else {
      api.reload('501fabea', component.options)
    }
    module.hot.accept("./stockUpReceiveOrders.vue?vue&type=template&id=501fabea&scoped=true", function () {
      api.rerender('501fabea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/stockUpReceiveOrders.vue"
export default component.exports